<template>
  <div v-loading="loading">
    <h3>Customer Logo Form - {{ $route.params.id ? 'Edit' : 'Create' }}</h3>
    <hr class="my-4" />
    <div id="form-container" class="pt-2"></div>
    <el-form
      ref="elForm"
      :model="formData"
      :rules="validationRules"
      size="medium"
      label-width="auto"
      disabled
    >
      <el-form-item label="DCO Id" prop="DcoId">
        <el-input v-model="formData.DcoId" placeholder="Tag Name"></el-input>
      </el-form-item>
      <el-form-item label="Company Name" prop="Company">
        <el-input v-model="formData.Company" placeholder="Tag Name"></el-input>
      </el-form-item>
    </el-form>

    <div class="flex space-x-0 space-y-2 lg:space-x-2 lg:space-y-0">
      <div
        @click="uploadButton"
        class="flex flex-col items-center justify-center w-64 h-32 border border-gray-400 rounded-lg cursor-pointer"
      >
        <input
          @change="onFileChange"
          type="file"
          class="hidden"
          ref="uploadButton"
          accept=".png"
        />
        <i class="text-4xl text-blue-600 el-icon-upload" />
        <p class="text-md">Select File to upload</p>
      </div>

      <div
        v-if="displayLogo && formData.uploadedFile"
        class="flex large-12 space-x-1 medium-12 small-12 cell"
      >
        <div class="flex">
          <img :src="formData.uploadedFile" class="h-32" />
          <span class="remove-file" v-on:click="handleRemove()"
            ><i class="text-xl cursor-pointer el-icon-close"
          /></span>
        </div>
      </div>
    </div>
    <div class="pt-2 text-xs italic">*Supported file types are: .png</div>
    <div style="margin-top: 2px;" class="text-xs italic">
      *Maximum PNG size is 1 MB
    </div>

    <hr class="my-4" />
    <div class="w-full text-right">
      <el-button
        type="primary"
        @click="submit"
        :disabled="!formData.uploadedFile"
        >Submit</el-button
      >
      <el-button @click="cancel">Cancel</el-button>
    </div>
  </div>
</template>

<script>
import formService from '@/mixins/FormService'
import formHelper from './form-helper'
// import { DxButton } from 'devextreme-vue'
// import { DxForm, DxSimpleItem, DxLabel } from 'devextreme-vue/form'
import appsettings from '@/config.json'

let service

export default {
  components: {
    // DxButton,
    // DxForm,
    // DxSimpleItem,
    // DxLabel
  },
  created() {
    service = new formService(this, formHelper)
  },
  async mounted() {
    this.loading = true
    this.formData = await service.initialFormData()
    this.formData.uploadedFile = ''

    this.getLogoSource()

    if (this.$route.params.id) {
      this.mode = 'edit'
    }
    this.loading = false
  },
  data() {
    return {
      apiGetById: this.$appInfo.api.customer.getById,
      apiPost: this.$appInfo.api.customer.post,
      apiPut: this.$appInfo.api.customer.put,
      formData: formHelper.getEmptyData(),
      validationRules: formHelper.getValidationRule(),
      roles: [],
      costumers: [],
      mode: '',
      isSubmit: false,
      loading: false,
      dialogImageUrl: '',
      dialogVisible: false,
      availableLogo: '',
      selectedFiles: false,
      displayLogo: false
    }
  },
  methods: {
    elog(e) {
      console.log(e)
    },
    uploadButton() {
      this.$refs.uploadButton.click()
    },
    createImage(file) {
      var _this = this
      this.displayLogo = false

      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      }).then((data) => {
        _this.formData.uploadedFile = data
        _this.displayLogo = true
      })
    },
    async onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files

      if (!files.length) return

      // Allowing file type
      let allowedExtensions = /(\png)$/i
      if (!allowedExtensions.exec(files[0].type)) {
        let splitExt = files[0].name.split('.')
        let ext = splitExt[splitExt.length - 1]
        let fileName =
          files[0].name.length >= 30
            ? `${files[0].name.substr(0, 30)}...${ext}`
            : files[0].name

        this.$message.error(`Sorry, ${fileName} is invalid file type`)
        return false
      }

      // Allowing file size
      let fileSize = Math.round(files[0].size / 1024)
      if (fileSize >= 1024) {
        this.$message.error(`File too big, please select a file less than 1 MB`)
        return
      }

      this.formData.uploadedFileRaw = files[0]
      console.log('formData', this.formData.uploadedFileRaw)
      await this.createImage(files[0])
    },
    async cancel() {
      this.$router.go(-1)
    },
    async submit() {
      this.$refs.elForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            this.isSubmit = true
            let formData = new FormData()
            formData.append('uploadedFile', this.formData.uploadedFileRaw)

            const res = await this.$axios.post(this.getUploadUrl(), formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })

            this.$message.success('Data Saved')
            this.$router.push({ name: 'customer-logo-list' })
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$message.error(e)
            console.log(e)
          }
        } else {
          this.$message.warning('Please fill in the required data')
          this.loading = false
          return false
        }
      })
    },
    async getLogoSource() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.customer.getLogoBase64 +
            `?customer_name=${this.formData.DcoId}`
        )
        this.formData.uploadedFile = res.data
        this.displayLogo = true
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },

    getUploadUrl() {
      return (
        appsettings.baseUrl +
        '/' +
        this.$appInfo.api.customer.insertLogo +
        `?customer_name=` +
        this.formData.DcoId
      )
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isImage =
        file.raw.type === 'image/png' ||
        file.raw.type === 'image/gif' ||
        file.raw.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('Avatar picture must be an Image format!')
      }
      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!')
      }

      if (isImage && isLt2M) {
        // set selectedFiles status
        this.selectedFiles = true
      }

      return isImage && isLt2M
    },
    handleRemove() {
      this.displayLogo = false
      this.formData.uploadedFile = ''
      this.formData.uploadedFileRaw = null
      this.displayLogo = true
      this.$refs.uploadButton.value = null
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSubmit) {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      )
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>
